import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Spinner, Table } from "reactstrap";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Container from "../../../components/Container";
import AppLayout from "../../../components/layouts/AppLayout";
import API from "../../../utils/API";
import Create from "./Create";
import Delete from "./Delete";
import Edit from "./Edit";

const Index = () => {
  const [faculties, setFaculties] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchFaculties = async () => {
    try {
      const data = (await API.get("/api/faculties")).data.data;
      setFaculties(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaculties();
  }, [refresh]);

  return (
    <AppLayout>
      <Breadcrumbs
        title="Faculties"
        links={[
          {
            title: "Dashboard",
            link: null,
          },
          {
            title: "Faculties",
            link: null,
          },
        ]}
      />
      <Container>
        <Card className="border-0 shadow mt-5" style={{ minHeight: "70vh" }}>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h1 className="mb-0">All Faculties</h1>
              <Create faculty={faculties} fetchFaculties={fetchFaculties} />
            </div>
            <Table hover responsive>
              <thead>
                <tr className="bg-shade-blue">
                  <th>#</th>
                  <th>Name</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {faculties.length > 0 ? (
                  faculties.map((faculty, index) => (
                    <tr
                      key={`faculty-${faculty.id}`}
                      style={{ verticalAlign: "middle" }}>
                      <th scope="row">{index + 1}</th>
                      <td>{faculty.name}</td>
                      <td>{moment(faculty.created_at).format("DD/MM/YY")}</td>
                      <td>{moment(faculty.updated_at).format("DD/MM/YY")}</td>
                      <td>
                        <Edit
                          faculty={faculty}
                          fetchFaculties={fetchFaculties}
                        />
                        <Delete
                          faculty={faculty}
                          refresh={refresh}
                          setRefresh={setRefresh}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      {loading ? (
                        <Spinner style={{ width: "30px", height: "30px" }} />
                      ) : (
                        "No Faculties Exists"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </AppLayout>
  );
};

export default Index;
